import styled, { css } from 'styled-components'

const Hint = styled.div<{ isSuccess?: boolean; isDanger?: boolean; isWarning?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 20px;
  font: var(--theme-typography-bodyM-semiBold);

  ${({ isSuccess }) =>
    isSuccess &&
    css`
      background-color: var(--theme-colors-theme-brand-transparent-opacity12);
    `}
  ${({ isDanger }) =>
    isDanger &&
    css`
      background-color: var(--theme-colors-theme-negative-transparent-opacity12);
    `}
  ${({ isWarning }) =>
    isWarning &&
    css`
      background-color: var(--theme-colors-theme-warning-transparent-opacity12);
    `}
`

export const s = { Hint }
